import { concatWithPrefix } from '@sravni/cosago-react-library/lib/utils';

import { formatPhone } from 'commonUtils/formatters/formatPhone';
import { HIDE_DATA_SYMBOL, UNBREAKABLE_SEPARATOR } from 'constants/string';

export const getProtectedTitleWithUserData = (additionalPhone?: string, isHideData = false) => {
  if (!additionalPhone) return '';

  return isHideData
    ? concatWithPrefix('Доп. номер', formatPhone(HIDE_DATA_SYMBOL.repeat(10), false), UNBREAKABLE_SEPARATOR)
    : concatWithPrefix('Доп. номер', formatPhone(additionalPhone), UNBREAKABLE_SEPARATOR);
};
